<template>
	<div class="z-40 flex h-[calc(100vh-288px)] min-h-56 w-screen items-center justify-center bg-linear-to-bl from-logi-grey-600 via-black to-black pt-20">
		<div class="flex flex-col items-center justify-center">
			<div class="relative flex animate-pulse items-center justify-center rounded-full">
				<i class="fa-thin fa-spinner-third animate-spin text-3xl font-bold text-white/50"></i>
			</div>
		</div>
	</div>
</template>
